import { Component, HostBinding, ElementRef, HostListener, Renderer2, Inject, ViewChild } from '@angular/core';
import { CommonModule, DOCUMENT } from '@angular/common';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from '@env/environment';

interface ContactOption {
  icon: string;
  label: string;
}

@Component({
  selector: 'app-help-to-call',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  templateUrl: './help-to-call.component.html',
  styleUrl: './help-to-call.component.scss',
})
export class HelpToCallComponent {

  @ViewChild('callModal') modalRef!: ElementRef;

  @HostBinding('class.is-clicked')
  isClicked: boolean = false;

  public isClickToCallReady: boolean = false;
  public isCallActive: boolean = false;

  contactOptions: ContactOption[] = [
    { icon: 'whatsapp-custom', label: 'WhatsApp' },
    { icon: 'call', label: 'Llámanos' }
  ];

  constructor(
    private readonly matIconRegistry: MatIconRegistry,
    private readonly sanitizer: DomSanitizer,
    private readonly elementRef: ElementRef,
    private readonly renderer: Renderer2,
    @Inject(DOCUMENT) private readonly document: Document
  ) {
    this.matIconRegistry.addSvgIcon(
      'whatsapp-custom',
      this.sanitizer.bypassSecurityTrustResourceUrl('./assets/img/seguroCelular.png')
    );
  }


  private checkAndClose(event: Event): void {
    if (this.isClicked && !this.elementRef.nativeElement.contains(event.target)) {
      this.isClicked = false;
    }
  }

  @HostListener('document:click', ['$event'])
  clickout(event: Event): void {
    this.checkAndClose(event);
  }

  @HostListener('document:touchstart', ['$event'])
  touchout(event: Event): void {
    this.checkAndClose(event);
  }

  toggleClickState(event: MouseEvent | TouchEvent | undefined): void {
    event?.stopPropagation();
    this.isClicked = !this.isClicked;
  }

  handleAction(type: 'whatsapp' | 'tel', target: string, event?: MouseEvent | TouchEvent): void {
    event?.stopPropagation();

    if (type === 'whatsapp') {
      window.open(`https://nam02.safelinks.protection.outlook.com/?url=https%3A%2F%2Fprotect.checkpoint.com%2Fv2%2Fr01%2F___https%3A%2F%2Fwa.link%2FDo9vAs___.Y3AxOnN1cmE6YzpvOjM3ZWExZGQ0NDc3MjliZDRjNTVlZjhkN2M3MDAyY2UyOjc6ZDI0NjphMDJlZmFiNjE5NGUwMTkyMDFkM2EwNDAyNWU4ZDNmNzllNDA1ZjgxYzc4M2E3NmI4OGYxZjVlMjA1MTk4MGI0Omg6VDpU&data=05%7C02%7Cluceroalvarez%40sura.com%7C2136996786ca45185d4a08ddf0726389%7C3c0bd4fe11114d138e0c7c33b9eb7581%7C0%7C0%7C638931096914472497%7CUnknown%7CTWFpbGZsb3d8eyJFbXB0eU1hcGkiOnRydWUsIlYiOiIwLjAuMDAwMCIsIlAiOiJXaW4zMiIsIkFOIjoiTWFpbCIsIldUIjoyfQ%3D%3D%7C0%7C%7C%7C&sdata=vYDR7zQwvzWVWOpMB%2BTZJ%2FqHBjURNEDVrFFNtSq8jJ4%3D&reserved=0`, '_blank');
    } else if (type === 'tel') {
      if (typeof (window as any).ClickToCall === 'function') {
        console.log('Iniciando llamada con ClickToCall...');
        (window as any).ClickToCall();
        this.isCallActive = true;

        setTimeout(() => {
          if (this.modalRef && this.modalRef.nativeElement) {
            // Mueve el elemento modal fuera del componente y al <body>
            this.renderer.appendChild(this.document.body, this.modalRef.nativeElement);
          }
        }, 0);
      } else {
        console.warn('ClickToCall no está listo o la función no se pudo encontrar.');
      }
    }
    this.isClicked = false;
  }

  hangUpCall(event?: MouseEvent | TouchEvent): void {
    event?.stopPropagation();
    console.log('Finalizando llamada con ClickToCall...');
    if (typeof (window as any).ClickToEndCall === 'function') {
      (window as any).ClickToEndCall();

      this.isCallActive = false; 

      if (this.modalRef && this.modalRef.nativeElement.parentNode === this.document.body) {
        this.renderer.removeChild(this.document.body, this.modalRef.nativeElement);
      }

    }
    this.isClicked = false;
  }
}